// @flow

import { makeApiCall } from '../../../../../services/apiService/apiService';
import {
  addCellPrefixAction,
  getBaseFailureObject,
  getBasePendingApiObject,
  getBaseSuccessfulObject,
  loadingMessages
} from '../../../shopFloorManagement/masterData/masterDataRedux/masterDataActionCreator';
import { toastr } from 'react-redux-toastr';
import {
  BlockCNMessages,
  UnblockCNMessages
} from '../../../../helper/Constants';

export const blockCnDashboardActions = {
  GET_DASHBOARD_DATA: 'GET_DASHBOARD_DATA',
  FILTER_DASHBOARD_DATA: 'FILTER_BLOCK_CN_DASHBOARD_DATA',
  DELETE_CN: 'DELETE_CN',
  UNBLOCKED_CNS_DATA: 'UNBLOCKED_CNS_DATA'
};

export const getDashboardDataAction = (load: Object) => ({
  type: blockCnDashboardActions.GET_DASHBOARD_DATA,
  payload: load
});

export const filterDashboardData = (load: Object) => ({
  type: blockCnDashboardActions.FILTER_DASHBOARD_DATA,
  payload: load
});

export const deleteCnAction = (load: Object) => ({
  type: blockCnDashboardActions.DELETE_CN,
  payload: load
});

export const getUnblockedCnsDataAction = (load: Object) => ({
  type: blockCnDashboardActions.UNBLOCKED_CNS_DATA,
  payload: load
});

function GetDashboardFailurePayload(dispatch, res) {
  dispatch(
    getDashboardDataAction({
      isLoading: false,
      isLoaded: true,
      dashboardData: [],
      dashboardDataFiltered: [],
      error: res.errorMessage || BlockCNMessages.GET_FAIL
    })
  );
}

function getUnblockedCnsFailurePayload(dispatch, res) {
  dispatch(
    getUnblockedCnsDataAction({
      isLoading: false,
      isLoaded: true,
      dashboardData: [],
      dashboardDataFiltered: [],
      error: res.errorMessage || BlockCNMessages.GET_UNBLOCKED_FAIL
    })
  );
}

export const getUnblockedCnsData = obj => (dispatch: Function) => {
  dispatch(
    getUnblockedCnsDataAction({
      isLoading: true,
      isLoaded: false,
      dashboardData: [],
      dashboardDataFiltered: [],
      error: null,
      result: []
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getUnblockedCns',
    method: 'POST',
    data: filteredData(obj.cnote),
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getUnblockedCnsDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: res.payload,
            dashboardDataFiltered: res.payload,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getUnblockedCnsDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: [],
            dashboardDataFiltered: [],
            error: res.errorMessage || BlockCNMessages.GET_UNBLOCKED_FAIL
          })
        );
      }
      const inputCnotes = filteredData(obj.cnote) || [];
      const cnotesReceivedInResponse = (res.payload || []).map(c => c.cnote);
      const notReceivedCnotesInResponse = inputCnotes.filter(
        cnote => cnotesReceivedInResponse.indexOf(cnote) === -1
      );
      let uiMessage =
        'Cnotes not found in unblocked state: ' +
        notReceivedCnotesInResponse.join(', ');
      if (notReceivedCnotesInResponse.length > 0) {
        dispatch(
          addCellPrefixAction(
            getBaseFailureObject({ cellData: null }, uiMessage)
          )
        );
      }
    },
    failureCb: res => {
      getUnblockedCnsFailurePayload(dispatch, res);
    },
    catchCb: res => {
      getUnblockedCnsFailurePayload(dispatch, res);
    }
  };

  return makeApiCall(requestObj);
};

export const getDashboardData = obj => (dispatch: Function) => {
  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false,
      dashboardData: [],
      dashboardDataFiltered: [],
      error: null,
      result: []
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getBlockedCnList',
    method: 'POST',
    data: obj.reasonIds,
    replaceParamsArr: [
      { key: 'toDateTime', val: obj.endDate },
      { key: 'fromDateTime', val: obj.startDate }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: res.payload,
            dashboardDataFiltered: res.payload,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: [],
            dashboardDataFiltered: [],
            error: res.errorMessage || BlockCNMessages.GET_FAIL
          })
        );
      }
    },
    failureCb: res => {
      GetDashboardFailurePayload(dispatch, res);
    },
    catchCb: res => {
      GetDashboardFailurePayload(dispatch, res);
    }
  };

  return makeApiCall(requestObj);
};

function AddBlockerFailurePayload(dispatch, res) {
  dispatch(
    addCellPrefixAction(
      getBaseFailureObject(res, BlockCNMessages.ADD_FAIL, {
        cellData: null
      })
    )
  );
}

const filteredData = val => {
  return val.split(',').filter((value, index, self) => {
    return self.indexOf(value) === index && value !== '';
  });
};

export const onAddingToBlockListAction = (
  requestParams: Object,
  cb: Function = () => {}
) => (dispatch: Function) => {
  dispatch(
    addCellPrefixAction(
      getBasePendingApiObject(
        { cellData: null },
        loadingMessages.CREATE_UPDATE_CELL_PREFIX
      )
    )
  );

  const requestObj = {
    apiEndPoint: 'blockCN',
    baseUrl: 'zoomApiUrl',
    method: 'POST',
    data: filteredData(requestParams.cnote),
    replaceParamsArr: [
      { key: 'reasonId', val: requestParams.reasonId },
      {
        key: 'consignmentBlockerRequestType',
        val: requestParams.consignmentBlockerRequestType
      }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        cb();
        dispatch(
          addCellPrefixAction(
            getBaseSuccessfulObject(
              { cellData: res.payload },
              BlockCNMessages.SUCESS
            )
          )
        );
      } else {
        dispatch(
          addCellPrefixAction(
            getBaseFailureObject(res, BlockCNMessages.ADD_FAIL, {
              cellData: null
            })
          )
        );
      }
    },
    failureCb: res => {
      AddBlockerFailurePayload(dispatch, res);
    },
    catchCb: res => {
      AddBlockerFailurePayload(dispatch, res);
    }
  };

  return makeApiCall(requestObj);
};

export const onRemoveFromBlockListAction = (
  requestParams: Object,
  cb: Function = () => {}
) => (dispatch: Function) => {
  dispatch(
    addCellPrefixAction(
      getBasePendingApiObject(
        { cellData: null },
        loadingMessages.CREATE_UPDATE_CELL_PREFIX
      )
    )
  );
  const requestObj = {
    apiEndPoint: 'unblockCn',
    baseUrl: 'zoomApiUrl',
    method: 'POST',
    data: {
      cnotes: filteredData(requestParams.cnote),
      reasonId: requestParams.reasonId
    },
    successCb: res => {
      if (res.status === 'SUCCESS') {
        cb();
        let responseDetails = res.payload || [];
        let unblockDetails = {
          successCN: [],
          invalidCN: [],
          reasonMismatchCN: []
        };

        responseDetails.map(cnDetail => {
          if (cnDetail.message === 'SUCCESS') {
            unblockDetails.successCN.push(cnDetail.cnote);
          } else if (
            cnDetail.message === 'CN_BLOCKER_NOT_FOUND_FOR_GIVEN_REASON'
          ) {
            unblockDetails.reasonMismatchCN.push(cnDetail.cnote);
          } else {
            unblockDetails.invalidCN.push(cnDetail.cnote);
          }
        });

        let successMessage = '';
        if (unblockDetails.successCN.length > 0) {
          successMessage += `${unblockDetails.successCN.length}/${responseDetails.length} ${UnblockCNMessages.SUCCESS}`;
        }
        if (unblockDetails.reasonMismatchCN.length > 0) {
          successMessage += successMessage !== '' ? ' and ' : '';
          successMessage += `${unblockDetails.reasonMismatchCN.length}/${responseDetails.length} ${UnblockCNMessages.CN_BLOCKER_NOT_FOUND_FOR_GIVEN_REASON}`;
        }
        dispatch(
          addCellPrefixAction(
            getBaseSuccessfulObject({ cellData: null }, successMessage)
          )
        );
        if (unblockDetails.invalidCN.length > 0) {
          toastr.error(
            'Error',
            `${unblockDetails.invalidCN.join(', ')} ${
              UnblockCNMessages.INVALID_CNOTE
            }`
          );
        }
      }
    },
    failureCb: res => {
      AddBlockerFailurePayload(dispatch, res);
    },
    catchCb: res => {
      AddBlockerFailurePayload(dispatch, res);
    }
  };
  return makeApiCall(requestObj);
};
